module.exports = __webpack_public_path__ + "static/machine-learning-icon-b88561da618a14411b3e36bfa0de5b35.png";